<template>
	<td>
		<div class="dl-container" v-if="data.notice">
			<div class="dl" 
				@click="
					downloadItem({
						url: data.notice,
						label: data.notice,
					})
				">
				<img
					src="/img/txt-icon.svg"
					alt=""
				/>
				<span class="table__description">Télécharger la notice</span>
			</div>
		</div>
		<div class="dl-container" v-if="data.type == `Calendrier de l'Avent`">
			<div class="dl" @click="showCalendarSoluce(data.id)">
				<img
					src="/img/txt-icon.svg"
					alt=""
				/>
				<span class="table__description">Voir la correction</span>
			</div>
		</div>
		<div class="dl-container" v-if="data.type == `TileGame`">
			<div class="dl" @click="showTileGameSoluce(data.id)">
				<img
					src="/img/txt-icon.svg"
					alt=""
				/>
				<span class="table__description">Voir la correction</span>
			</div>
		</div>
		<div class="dl-container" v-if="data.type == `QCM`">
			<div class="dl" @click="showQcmSoluce(data.id)">
				<img
					src="/img/txt-icon.svg"
					alt=""
				/>
				<span class="table__description">Voir la correction</span>
			</div>
		</div>
		<div class="dl-container" v-if="data.type === `Activité rituelle`">
			<div class="dl" @click="showActiviteRituelleSoluce(data.id)">
				<img
					src="/img/txt-icon.svg"
					alt=""
				/>
				<span class="table__description">Voir la correction</span>
			</div>
		</div>
		<pop-up-calendar-soluce
			@close="isVisibleCalendarSoluce = !isVisibleCalendarSoluce"
			:id="data.id"
			v-if="isVisibleCalendarSoluce"
		/>
		<pop-up-tile-game-soluce
			@close="isVisibleTileGameSoluce = !isVisibleTileGameSoluce"
			:id="data.id"
			v-if="isVisibleTileGameSoluce"
		/>
		<PopUpQCMSoluce 
			v-if="isQcmSoluceVisible" 
			@close="isQcmSoluceVisible = !isQcmSoluceVisible" 
			:id="data.id"
		/>
		<PopUpQuestionFlashSoluce 
			v-if="isActiviteRituelleVisible" 
			@close="isActiviteRituelleVisible = !isActiviteRituelleVisible" 
			:questions="data" 
		/>
	</td>
</template>

<script>
import { authenticatedImageFetch } from '../../../../utils/utils'
import PopUpQCMSoluce from '../../../PopUp/QCM/PopUpQCMSoluce.vue'
import PopUpQuestionFlashSoluce from '../../../PopUp/QuestionFlashPackage/PopUpQuestionFlashSoluce.vue'
import PopUpCalendarSoluce from '../../../PopUp/SeriousGame/Calendar/PopUpCalendarSoluce.vue'
import PopUpTileGameSoluce from '../../../PopUp/SeriousGame/TileGame/PopUpTileGameSoluce.vue'
export default {
	components: { PopUpCalendarSoluce, PopUpTileGameSoluce, PopUpQCMSoluce, PopUpQuestionFlashSoluce },
	props: {
		data: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			isVisibleCalendarSoluce: false,
			isVisibleTileGameSoluce: false,
			isQcmSoluceVisible: false,
			isActiviteRituelleVisible: false
		}
	},
	methods: {
		async downloadItem({ url, label }) {

			const response = await authenticatedImageFetch(url, { method: 'GET', responseType: "blob" })
				.then((response) => response.blob())


			const blob = new Blob([response])
			const link = document.createElement("a")
			link.href = URL.createObjectURL(blob)
			link.download = label
			link.click()
			URL.revokeObjectURL(link.href)
		},
		showCalendarSoluce() {
			this.isVisibleCalendarSoluce = !this.isVisibleCalendarSoluce
		},
		showTileGameSoluce() {
			this.isVisibleTileGameSoluce = !this.isVisibleTileGameSoluce
		},
		showQcmSoluce(){
			this.isQcmSoluceVisible = !this.isQcmSoluceVisible
		},
		showActiviteRituelleSoluce(){
			this.isActiviteRituelleVisible = !this.isActiviteRituelleVisible
		}
	},
}
</script>

<style>
</style>
